module.exports = __webpack_public_path__ + "static/img/valueBottom.a54aede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/valueBottom.png
// module id = ShO7
// module chunks = 0